import { connect } from 'react-redux'
import { SignUp } from '../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignUp)


// WEBPACK FOOTER //
// ./src/Pages/SignUp/containers/SignUp.js